export default {
  nav: {
    index: '首页',
    about: '关于爱瑟福',
    news: '新闻动态',
    products: '产品与方案',
    download: '文件下载',
    login: '平台演示',
    contact: '联系我们'
  },
  home: {
    productSolutions: '产品与方案',
    ota: 'eSync OTA平台',
    diagnosis: '远程诊断平台',
    vehicle: '基础软件',
    eLearn: 'eLearn数据模型分析平台',
    test: '自动化测试',
    tool: '工具链',
    otaContent: 'OTA英文全称是Over-the-Air Technology/空中下载技术，可以理解为一种远程无线升级技术即通过网络从远程服务器下载新的软件更新包对自身系统进行升级， 包含固件升级和应用升级， 从而满足终端厂商的应用管理需求和运营商对入网终端的管理要求。<br/><br/>OTA升级可以分为三个阶段， 即生成更新包、传输更新包、安装更新， 整个阶段通过...',
    diagnosisContent: '随着汽车向智能化方向发展，现代电子控制技术已渗透至汽车的各部分，汽车的ECU也越来越复杂，传统的汽车诊断面临诸多问题：<p>对于车企</p>开发成本高昂，单价贵，并且需要根据不同项目单独开发，对已知故障容易处理，但对...',
    vehicleContent: '在SDV（软件定义汽车）的背景下，更高带宽的车载以太网作为主干网，同时SOA设计逐步应用到整车架构设计中，爱瑟福基础软件产品经过多年产品开发和迭代，基础软件产品从以太网协议栈产品逐步过渡到轻量化SOA中间件产品，主要产品有SOME/IP、DoIP、UDS、AVB/TSN和FS-COM等。',
    eLearnContent: '通过对研发路测车辆的车辆数据收集，进行分析，利用算法或机器学习，构建特定数据模型，实现车辆故障自动识别，自动定位分析，并且可扩展迭代的车辆数据分析平台。<br/><br/>该平台分析来自车辆的数据，例如传感器读数和车辆位置，以及源自其他来源的数据，例如道路和天气状况，以提供建议和发现趋势...',
    learnMore: '了解更多',
    corporateVision: '企业愿景',
    corporateVisionContent: '爱瑟福致力为客户提供以太网软件开发，车联网平台等创新产品',
    corporateVisionTitle: '打造一流的软件服务型企业',
    serviceTitle: '提供专业的服务',
    serviceContent: '专注于汽车软件开发的服务商, 产品研发中心设在上海, 武汉, 长春, 公司立志成为国内一流的汽车软件服务企业。',
    serviceItemTitle0: 'OTA设计咨询',
    serviceItemTitle1: 'OTA开发测试运维服务',
    serviceItemTitle2: 'OTA海外出口',
    serviceItemTitle3: '测试服务',
    serviceItemTitle4: '以太网协议栈开发',
    serviceItemTitle5: '车内SOA中间件开发',
    aboutTitle: '专注于汽车软件开发的服务商',
    aboutContent: '爱瑟福信息科技（上海）有限公司成立于2017年，是一家专注于汽车软件开发的服务商，产品研发中心设在上海，武汉，长春，公司立志成为国内一流的汽车软件服务企业，为汽车相关企业提供车内以太网及车联网产品整体解决方案，2020年富晟集团下富强基金对其首轮投资，2022年8月富晟集团旗下富钛字节公司完成对其的收购控股，依托双方股东资源完成全球化布局。',
    year: '年',
    researchDevelopmentBase: '研发基地',
    customerNumber: '客户数量'
  },
  about: {
    excelfore: '公司简介',
    service: '提供专业的服务',
    slogan: 'Company Profile',
    cooperativeCustomer: '合作客户',
    mainEnginePlant: '主机厂',
    partPlant: '零部件',
    internet: '互联网',
    partner: '合作伙伴',
    domesticCustomer: '国内客户',
    foreignCustomer: '国外客户',
    coverMajorOems: '覆盖主要主机厂',
    coverMajorModels: '覆盖主要车型',
    totalNumberVehiclesCovered: '覆盖车辆总数',
    numberVehicleUpgrades: '车辆升级次数',
    collaborativeDevelopment: '三地团队协同开发',
    shanghai: '上海',
    shanghaiAddressDetail: '上海市徐汇区钦州北路光启园5号楼202A室',
    wuhan: '武汉',
    wuhanAddressDetail: '湖北省武汉市洪山区野芷湖西路创客星南站304室',
    changchun: '长春',
    changchunAddressDetail: '吉林省长春市净月区中懋天地20楼',
    qualificationHonor: '资质荣誉',
    corePatentDetail: '核心专利20+： 包括以太网协议栈设计、差分算法等',
    '2017Awards': '2017最具投资价值产品奖',
    '2018Awards': '2018年国家智能汽车优秀创新项目',
    '2021Awards': '2021年智能网联汽车逐鹿奖',
    '2022Awards': '2022年上海专精特新企业之一',
    softwareLiterature: '软件著作',
    corePatent: '核心专利',
    milestones: '发展历程',
    '2017Milestones01': '公司成立',
    '2017Milestones02': '获得第一家OEM车企OTA项目',
    '2017Milestones03': '获得第一家零部件供应商以太网协议栈项目',
    '2017Milestones04': '荣获年度汽车电子科学技术奖突出创新产品奖',
    '2017Milestones05': 'eSync联盟成立，推进OTA相关业务流程的标准化',
    '2018Milestones01': '获得第一家互联网厂商OTA项目',
    '2018Milestones02': '获得OEM车企，以太网协议栈集采项目',
    '2018Milestones03': '荣获2018年汽车智能化技术优秀创新项目奖，最具投资价值产品奖',
    '2019Milestones01': '实现整车车型OTA量产',
    '2019Milestones02': '和某主机厂签订三年内所有车型的OTA开发合同',
    '2019Milestones03': '获得第一个商用车OTA项目',
    '2019Milestones04': '获得高新技术企业资质',
    '2020Milestones01': '获得富晟集团天使轮融资',
    '2020Milestones02': '远程诊断产品客户项目落地',
    '2020Milestones03': '远程诊断产品客户项目落地',
    '2020Milestones04': '获取第一个自动驾驶零部件公司OTA项目',
    '2021Milestones01': '21年上海年度智能网联技术逐路奖',
    '2021Milestones02': '获取第一个主机厂网关中间件项目',
    '2022Milestones01': '获得上海认定的专精特新企业',
    '2022Milestones02': '成立武汉新公司',
    '2023Milestones01': '富晟集团完成收购及控股爱瑟福公司',
    '2023Milestones02': '搭载OTA组件的车辆数总数突破300W辆，搭载远程诊断组件的车辆数突破80W辆',
    '2023Milestones03': '武汉公司，上海公司整体搬迁至新的办公室',
    '2024Milestones01': '获取第一个商用车项目',
    '2024Milestones02': '搭载OTA组件的车辆数总数突破400W辆'
  },
  contact: {
    address: '地址',
    addressContent: '上海市徐汇区钦州北路1001号光启园5号楼601室',
    business: '商务合作',
    businessEmail: 'sales@excelfore-china.com',
    hr: '简历投递',
    hrEmail: 'HR@excelfore-china.com',
    phone: '电话',
    phoneNumber: '17302121233',
    applyPosition: '申请职位',
    applyTry: '申请试用',
    name: '姓名',
    validName: '请输入您的姓名',
    email: '邮箱',
    emailTips: '建议使用公司邮箱',
    validEmail: '请输入您的邮箱',
    validEmailFormat: '请输入正确的邮箱',
    validPhone: '请输入您的电话号码',
    validPhoneFormat: '请输入正确的电话号码',
    companyName: '公司名称',
    validCompanyName: '请输入您的公司名称',
    remark: '备注',
    submitTips: '* 提交此表格即表示您同意我们的条款和隐私政策',
    submit: '提交',
    submitSuccess: '提交成功',
    cancel: '取消',
    systemError: '系统错误，请稍后重试'
  },
  footer: {
    product: '产品',
    connectUs: '联系我们',
    email: 'sales@excelfore-china.com',
    phone: '17302121233',
    address: '上海市徐汇区钦州北路1001号光启园5号楼601室',
    link: '网络链接',
    fawSn: '富晟集团',
    excelforeUs: 'Excelfore-US',
    followUs: '关注我们',
    copyright: '©2024 All Rights 爱瑟福信息科技(上海)有限公司 '
  },
  news: {
    newsTrends: '新闻动态',
    productDynamics: '产品动态',
    companyDynamics: '公司动态',
    industryDynamics: '行业动态'
  },
  product: {
    ota: {
      platform: 'eSync OTA Platform',
      introduce: '<p>OTA英文全称是Over-the-Air Technology/空中下载技术，可以理解为一种远程无线升级技术即通过网络从远程服务器下载新的软件更新包对自身系统进行升级， 包含固件升级和应用升级， 从而满足终端厂商的应用管理需求和运营商对入网终端的管理要求。</p>' +
        '<p>OTA升级可以分为三个阶段， 即生成更新包、传输更新包、安装更新， 整个阶段通过网络通信连接， 最终实现终端内存储数据的更新，进而改善终端的功能和服务的技术。</p>' +
        '<p>OTA技术是指系统层级的远程升级技术， 可以让汽车即便在已经离厂并且服役中的状态下， 能透过互联网从远程进行系统升级，以达到“功能更新、亦或是漏洞补救”的目的。</p>',
      overallPlan: '整体方案',
      deltaIntroduction: '差分算法介绍',
      productCharacteristics: '产品特性',
      characters01: '支持通信数据序列',
      characters02: '支持Method、Event、Filed通信方式',
      characters03: '支持SOME/IP TP',
      characters04: '完全兼容Adaptive AUTOSAR',
      characters05: '支持Android、Linux、QNX及RTOS系统',
      characters06: '灵活的配置方式',
      characters07: '成熟度高，经过100+量产项目检验',
      characters08: '经过AVNU认证产品',
      applicationScenario: '应用场景',
      carFactory: '车厂',
      carFactoryTitle01: '缩短研发时间',
      carFactoryContent01: '通过OTA升级通道, 车企在研发时间上会大大缩短, 部分新功能可以后续升级提供',
      carFactoryTitle02: '车辆OTA召回',
      carFactoryContent02: '车辆有问题时, 可以通过OTA手段进行召回, 实现召回成本的最小化',
      carFactoryTitle03: '车辆功能迭代升级',
      carFactoryContent03: '车辆可以通过OTA升级导入一些新功能，按需付费，提升用户体验，增强用户粘性',
      carFactoryTitle04: '安全漏洞修复',
      carFactoryContent04: '车辆有安全漏洞时，可以通过OTA手段及时修复，避免车辆收到不明攻击',
      carFactoryTitle05: '车辆运营',
      carFactoryContent05: '通过OTA平台，可以持续性的对现有车辆进行运营服务，以提升车企的服务价值',
      afterSale: '售后',
      afterSaleTitle01: '运营方式',
      afterSaleContent01: '降低运营维护门槛，相比传统的4S店线下模式，OTA的引入，更加偏向直营店模式',
      afterSaleTitle02: '召回成本',
      afterSaleContent02: '车辆有质量问题需要召回时，售后的成本及工作量是巨大的，包括人力的成本及客户召回服务的成本，OTA的引入可以降低大部分人力成本，特别是部分区域4S店未触达的情况下',
      afterSaleTitle03: '技术人员配备',
      afterSaleContent03: '软件刷写需要配备有专门技术人员，并涉及刷写工具软件及设备的采购，增加４S店的维修门槛及资金成本，通过OTA管道，可以降低这块对技术及设备的依赖性',
      afterSaleTitle04: '维修方式',
      afterSaleContent04: '之前的维修大部分在线下展开，后续的维修及升级可以在线上进行，通过OTA，远程诊断的方式，给用户提供更人性化的运维服务方式',
      vehicleOwner: '车主',
      vehicleOwnerTitle01: '常用常新',
      vehicleOwnerContent01: '车主对于车辆软件的更新迭代，可以有常用常新的体验，通常对品牌的认可度会提高',
      vehicleOwnerTitle02: '及时修复',
      vehicleOwnerContent02: '对于车辆使用中的问题，如果有OTA升级功能后，会更有期待感',
      vehicleOwnerTitle03: '增值服务',
      vehicleOwnerContent03: '通过车辆的OTA升级功能，体验或购买一些新的功能，可以有效延续车辆的生命周期',
      vehicleOwnerTitle04: '个性化服务',
      vehicleOwnerContent04: '车企可以提供各种主题，界面，性能等个性化服务，车主个性化需求'
    },
    diag: {
      platform: '远程诊断平台',
      introduce: '<p class="description-content">随着汽车向智能化方向发展，现代电子控制技术已渗透至汽车的各部分，汽车的ECU也越来越复杂，传统的汽车诊断面临诸多问题：</p>' +
        '<p class="description-title">对于车企</p>' +
        '<p class="description-content">开发成本高昂，单价贵，并且需要根据不同项目单独开发，对已知故障容易处理，但对未知复杂故障往往需要返厂或出差处理，效率低下，经济成本高。诊断数据隔离，难以收集到整车企业，诊修经验难以形成系统的规范的诊断知识库。</p>' +
        '<p class="description-title">对车主而言</p>' +
        '<p class="description-content">发生故障后只能被动等待维修，无法清晰了解故障信息。</p>' +
        '<p class="description-title">对4S店</p>' +
        '<p class="description-content">4S店也无法提前准备，维修周期较长，用户体验不佳。</p>' +
        '<p class="description-content">为了更好的节省开发成本，提升用户体验，降低用车风险和保修成本，弥补汽车智能化后，专业维修人员缺口导致的维修效率低，维修效果差的问题，车企开始将诊断与车联网、大数据结合，实现车辆的智能远程诊断。</p>',
      solution: '解决方案',
      applicationScenario: '应用场景',
      carFactory: '车厂',
      carFactoryTitle01: '设计研发: ',
      carFactoryContent01: '路试车辆<span class="marker-text">数据采集，远程诊断，实时监控。</span>',
      carFactoryTitle02: '生产下线: ',
      carFactoryContent02: '<span class="marker-text">下线诊断，版本验证。</span>',
      carFactoryTitle03: '运营管理: ',
      carFactoryContent03: '<p class="sub-content">数字化运营: 车辆状态管理，<span class="marker-text">故障预测，故障预警，零件质量分析改进，车辆大数据分析。</span></p>' +
        '<p class="sub-content"><span class="marker-text">诊断数据</span>平台化管理</p>' +
        '<p class="sub-content"><span class="marker-text">降低诊断仪的开发成本</span></p>',
      afterSale: '售后',
      afterSaleTitle01: '售后维修: ',
      afterSaleContent01: '远程诊断，<span class="marker-text">实时诊断，故障预诊断，偶发性故障排查，</span>主动式上门门维修服务',
      afterSaleTitle02: '维修指导: ',
      afterSaleContent02: '<span class="marker-text">远程维修协助，维修知识库</span>管理，<span class="marker-text">引导式</span>维修，<span class="marker-text">远程技师培训</span>',
      afterSaleTitle03: '维修数据共享: ',
      afterSaleContent03: '售后诊断仪数据的回收',
      vehicleOwner: '车主',
      vehicleOwnerTitle01: '车辆健康状态检测: ',
      vehicleOwnerContent01: '定制化维修保养指导',
      vehicleOwnerTitle02: '简单故障的自助维修，远程维修申请，预约维修，救援功能',
      vehicleOwnerTitle03: '车辆安全防护: ',
      vehicleOwnerContent03: '被盗提醒，车辆追踪(租借)， 减速及限制启动能力',
      vehicleOwnerTitle04: '绿色驾驶: ',
      vehicleOwnerContent04: '驾驶行为建议，燃油分析',
      vehicleOwnerTitle05: '个性化功能需求: ',
      vehicleOwnerContent05: '远程标定'
    },
    basic: {
      platform: '基础软件',
      introduce: '在SDV（软件定义汽车）的背景下，更高带宽的车载以太网作为主干网，同时SOA设计逐步应用到整车架构设计中，爱瑟福基础软件产品经过多年产品开发和迭代，基础软件产品从以太网协议栈产品逐步过渡到轻量化SOA中间件产品，主要产品有SOME/IP、DoIP、UDS、AVB/TSN和FS-COM等。',
      solution: '解决方案',
      applicationScenario: '应用场景',
      productFeature: '产品特点',
      someIp: 'SOME/IP协议栈',
      someIpSubTitle:"基于以太网的可扩展的面向服务的通信中间件",
      someIpContent: '<ul>' +
        '<li>支持通信数据序列</li>' +
        '<li>支持Method、Event、Filed通信方式</li>' +
        '<li>支持SOME/IP TP</li>' +
        '<li>完全兼容Adaptive AUTOSAR</li>' +
        '<li>支持Android、Linux、QNX及RTOS系统</li>' +
        '<li>灵活的配置方式</li>' +
        '<li>成熟度高，经过100+量产项目检验</li>' +
        '<li>经过AVNU认证产品</li>' +
        '</ul> ',
      doip: 'DOIP协议栈',
      doipSubTitle:"基于以太网的诊断数据传输协议",
      doipContent: '<ul>' +
        '<li>支持多Client和多Server端</li>' +
        '<li>支持多并发传输</li>' +
        '<li>遵循ISO13400规范</li>' +
        '<li>完全兼容Adaptive AUTOSAR</li>' +
        '<li>支持Android、Linux、QNX及RTOS系统</li>' +
        '<li>灵活的配置方式</li>' +
        '<li>成熟度高，经过100+量产项目检验</li>' +
        '<li>支持拖拽式的诊断序列配置</li>' +
        '</ul> ',
      avbTsn: 'AVB/TSN协议栈',
      avbTsnSubTitle:"时间敏感网络协议",
      avbTsnContent: '<ul>' +
        '<li>产品平台化，能够快速满足客户项目</li>' +
        '<li>支持IEEE 802.1AS、IEEE802.1AS-REV，IEEE802.1QAV，IEEE802.1QBV，IEEE802.1QCC，IEEE802.1Qat，IEEE802.1CB…</li>' +
        '<li>支持平台：Linux、QNX、安卓及RTOS</li>' +
        '<li>成熟度高，经过过个量产项目检验</li>' +
        '<li>经过AVNU认证产品</li>' +
        '</ul> ',
      videoIntroduction: '视频介绍',
      fsCom: 'FS-COM基础软件',
      fsComSubTitle:"面向服务的轻量化车载通信中间件",
      fsComContent: '<ul>' +
                '<li>遵循Adaptive AUTOSAR R22-11规范</li>' +
                '<li>支持多协议RawData、SOME/IP、DDS、DOIP、S2S等</li>' +
                '<li>支持CM、EM、SM、LOG、DCM、DEM等模块</li>' +
                '<li>支持E2E、TLS等通信安全机制</li>' +
                '<li>消耗资源少、占用空间小，执行效率高</li>' +
                '<li>可视化、灵活的IDE配置方式</li>' +
                '<li>IDE工具支持桌版本和云版本</li>' +
                '<li>IDE工具可支持标准的ARXML文件导入和无ARXML配置方式</li>' +
                '</ul> ',
      conventionalController:'传统控制器',
      conventionalControllerContent:'传统控制器开发差异较大，架构多样，在原有的框架上增加以太网通信功能成本较高，甚至要重新购买AUTOSAR软件包，爱瑟福协议栈平台化、工具化、成熟度高，兼容AUTOSAR接口，支持excel、ARXML等需求文件导入，不用对原有系统进行重新开发。如BCM、网格、座舱等。',
      domainController:'域控制器',
      domainControllerContent:'各个域控制器上的软件架构都在采用面向服务的SOA架构，SOA架构核心需要符合SOA架构的中间件支撑，爱瑟福的FS-COM产品是一款轻量化的、符合Adaptive AUTOSAR规范的车载通信基础软件，用户可以快速构建自有的应用平台，通过FS-Studio工具，能够更方便的生成应用接口，用户只需关注应用开发。如座舱域控、车身域控、智驾域控等。',
      vehicleNetworkDesign:'车载网络设计',
      vehicleNetworkDesignContent:'随着整车传感器的数量增加，对网络带宽、实时性、可靠性等要求不断提高，爱瑟福的AVB/TSN 协议栈是一款经过AVNU联盟认证的产品，已在国内外多款车型上搭载，经过多年的量产开发，能够快速适配市场主流芯片和操作系统，可以帮助快速交付。如座舱域控、智驾域控、区域控制器等。',
    },
    eLearn: {
      platform: 'eLearn数据模型分析平台',
      introduce: '<p>通过对研发路测车辆的车辆数据收集，进行分析，利用算法或机器学习，构建特定数据模型，实现车辆故障自动识别，自动定位分析，并且可扩展迭代的车辆数据分析平台。</p>' +
        '<p>该平台分析来自车辆的数据，例如传感器读数和车辆位置，以及源自其他来源的数据，例如道路和天气状况，以提供建议和发现趋势' +
        ' <span>· 建议：面向体验优化，包括更好的驾驶员辅助和车辆路线应用</span>' +
        ' <span>· 趋势：面向事件预测，车辆磨损和其他相关事件</span>' +
        '</p>',
      videoIntroduction: '视频介绍',
      solution: '解决方案',
      applicationScenario: '应用场景',
      productFeature: '产品特点',
      applicationScenarioTitle01: '问题分析',
      applicationScenarioContent01: 'eLearn可以从车辆组件中提取必要的数据，并在发生事故时提供给相关方',
      applicationScenarioTitle02: '行为分析',
      applicationScenarioContent02: '监控不安全和不良的驾驶行为',
      applicationScenarioTitle03: '电量优化',
      applicationScenarioContent03: '通过使用智能预测，eLearn平台可识别导致电池耗尽过多的因素并提出行动计划建议',
      applicationScenarioTitle04: '健康监控',
      applicationScenarioContent04: '24x7全天候监控车辆部件和传感器，提供实时警报和预测分析',
      applicationScenarioTitle05: '趋势分析',
      applicationScenarioContent05: '通过保养和燃料消耗的相关性以及润滑剂状态和燃料消耗之间的相关性等，提供车辆燃料趋势',
    },
    test: {
      platform: '自动化测试',
      introduce: '<p class="description-content">自动化测试(VTS-OTA)是基于虚拟台架和物理台架的OTA自动化测试系统，核心功能包括:开箱即用的OTA系统测试用例库、虚拟总线通讯、虚拟ECU、测试任务管理、测式报告管理等。自动化测试一方面够尽早在开发阶段，确保供应商/自主研发的OTA系统测试验证，另一方面能够确保SIL 阶段完成80%的测试用例，减少HIL和VIL的工作量。</p>' +
        '<p class="description-content">爱瑟福自动化测试方案致力于提供行业领先的虚实结合OTA测试方案，支持云端OTA测试场景定义，解决传统OTA测试无法进行多辆车并发测试的痛点。</p>',
      solution: '解决方案',
      applicationScenario: '应用场景',
      applicationScenarioTitle01: '自动化执行',
      applicationScenario01Content01: '全流程自动化执行, 无需人为参与',
      applicationScenario01Content02: '可监控过程日志, 生成先攻的测试报告和结果',
      applicationScenario01Content03: '单任务可执行多次，满足多版本比对测试结果',
      applicationScenarioTitle02: '大规模并发测试',
      applicationScenario02Content01: '可创建多个虚拟车辆，配置不同的测试场景',
      applicationScenario02Content02: '可同时进行多个虚拟车、多个测试',
      applicationScenario02Content03: '场景的并发测试',
      applicationScenario02Content04: '支持对选定虚拟车辆分批操作',
      applicationScenarioTitle03: '基于云端的协同',
      applicationScenario03Content01: '基于云端协同，可多人同时开展测试工作，不再受硬件制约，只能1V1开展工作',
      applicationScenario03Content02: '多人同时测试，工期至少降低2/3',
      applicationScenario03Content03: '不再受地点制约，在哪里都可以开展测试工作',
    },
    tool: {
      platform: '工具链',
      introduce: '<p>随着汽车行业向智能化和互联化的迅速发展，车辆系统的复杂性不断增加，要求高效的诊断和配置管理解决方案。企业面临着提高系统可靠性和操作效率的挑战。</p>' +
        '<p>爱瑟福的工具链产品由一系列工具组成：诊断脚本配置工具、诊断脚本仿真测试工具、诊断规范格式转换工具、车辆研发诊断软件、车辆售后诊断软件。可以满足汽车诊断平台功能设计，开发，测试场景的使用，能够帮助开发人员更加快速的实现功能设计，开发代码的编写及测试，缩短项目的研发周期。</p>',
      solution: '解决方案',
      solutionTitle01:'数据驱动架构',
      solutionContent01:'<ul>' +
              '<li>标准ODX/OTX</li>' +
              '<li>支持诊断协议DoCAN、DoIP、J1939</li>' +
              '</ul> ',
      solutionTitle02:'灵活的编辑',
      solutionContent02:'<ul>' +
              '<li>图形化的界面</li>' +
              '<li>流程化的编辑</li>' +
              '<li>结构化的展示 </li>' +
              '</ul> ',
      solutionTitle03:'强大的兼容',
      solutionContent03:'<ul>' +
              '<li>数据重复使用</li>' +
              '<li>格式转换</li>' +
              '<li>多种VCI 设备</li>' +
              '</ul> ',
      solutionTitle04:'实时结果反馈',
      solutionContent04:'<ul>' +
              '<li>数据检校</li>' +
              '<li>日志监控</li>' +
              '<li>验证报告生产</li>' +
              '</ul> ',
      applicationScenario: '应用场景',
      applicationScenarioTitle01: '车辆研发测试',
      applicationScenario01Content01: '车辆研发，测试使用，主要用于零件诊断，刷写',
      applicationScenario01Content02: '车辆问题排查: 用于对车辆故障问题进行分析，抓取总线数据及保存Trace数据',
      applicationScenarioTitle02: '远程诊断配套工具',
      applicationScenario02Content01: '用于诊断脚本编辑: 通过界面配置或图形化设置，创建远程诊断序列',
      applicationScenario02Content02: '用于诊断脚本验证: 验证诊断脚本编写的正确性',
      applicationScenarioTitle03: '售后维修工具',
      applicationScenario03Content01: '线下OTA及线下诊断维修',
      applicationScenario03Content02: '车辆售后维修使用，主要用于故障诊断，零件刷写等功能，适用于OTA升级，海外车辆快速维修场景等',
      applicationScenarioTitle04: '零件终端设备',
      applicationScenario04Content01: '面向核心零件供应商的诊断系统',
      applicationScenario04Content02: '用于面向诸如发动机，电池供应商的零件级别的诊断系统及硬件设备',
    },
  }
};
